import React, { useState, useEffect, useContext } from 'react'
import { Context } from '../../../context/app-context'
import './bannerHome.scss'

import { graphql, navigate, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import Button from '../../atoms/button/button'
import useGetInscription from '../../../utils/hooks/useGetInscription'
import useGetWinner from '../../../utils/hooks/useGetWinner'
import useMediaQuery from '../../../utils/useMediaQuery'
import ArrowScrollDown from '../../atoms/arrowScrollDown/arrowScrollDown'
import {
  ambassadorSelectedDate,
  finishDate,
  initialDate,
} from '../../../constants/activity-constants'

import icon_mision from '../../../assets/images/home/icon-mision.png'
import icon_rombo from '../../../assets/images/home/rombo-pink.png'

import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const BannerHome = () => {
  const [isAmbassador, isLoading] = useGetInscription()
  const [isWinner, isLoadingWinner, challengesCompleted] = useGetWinner()
  const [nameUser, setNameUser] = useState('')
  const { dispatch } = useContext(Context)

  const isMobile = useMediaQuery()

  const {
    bannerHomeLarge: { childImageSharp: bannerHomeLarge },
    bannerHomeMedium: { childImageSharp: bannerHomeMedium },
    bannerHomeSmall: { childImageSharp: bannerHomeSmall },
    bannerHomeLargeNot: { childImageSharp: bannerHomeLargeNot },
    bannerHomeMediumNot: { childImageSharp: bannerHomeMediumNot },
    bannerHomeSmallNot: { childImageSharp: bannerHomeSmallNot },
    bannerHomeLargeYes: { childImageSharp: bannerHomeLargeYes },
    bannerHomeMediumYes: { childImageSharp: bannerHomeMediumYes },
    bannerHomeSmallYes: { childImageSharp: bannerHomeSmallYes },
  } = useStaticQuery(graphql`
    {
      bannerHomeLarge: file(name: { eq: "banner-home-large" }) {
        childImageSharp {
          #                  gatsbyImageData
          gatsbyImageData(width: 1920, quality: 100)
        }
      }
      bannerHomeMedium: file(name: { eq: "banner-home-medium" }) {
        childImageSharp {
          #                  gatsbyImageData
          gatsbyImageData(width: 1366, quality: 100)
        }
      }
      bannerHomeSmall: file(name: { eq: "banner-home-small" }) {
        childImageSharp {
          gatsbyImageData(width: 1024, quality: 100)
        }
      }
      bannerHomeLargeNot: file(name: { eq: "banner-home-large-not" }) {
        childImageSharp {
          #                  gatsbyImageData
          gatsbyImageData(width: 1920, quality: 100)
        }
      }
      bannerHomeMediumNot: file(name: { eq: "banner-home-medium-not" }) {
        childImageSharp {
          #                  gatsbyImageData
          gatsbyImageData(width: 1366, quality: 100)
        }
      }
      bannerHomeSmallNot: file(name: { eq: "banner-home-small-not" }) {
        childImageSharp {
          gatsbyImageData(width: 1024, quality: 100)
        }
      }
      bannerHomeLargeYes: file(name: { eq: "banner-home-large-yes" }) {
        childImageSharp {
          #                  gatsbyImageData
          gatsbyImageData(width: 1920, quality: 100)
        }
      }
      bannerHomeMediumYes: file(name: { eq: "banner-home-medium-yes" }) {
        childImageSharp {
          #                  gatsbyImageData
          gatsbyImageData(width: 1366, quality: 100)
        }
      }
      bannerHomeSmallYes: file(name: { eq: "banner-home-small-yes" }) {
        childImageSharp {
          gatsbyImageData(width: 1024, quality: 100)
        }
      }
    }
  `)

  const [challenges, setChallenges] = useState([
    {
      txt: 'Reto #1',
      img: icon_rombo,
    },
    {
      txt: 'Reto #2',
      img: icon_rombo,
    },
    {
      txt: 'Reto #3',
      img: icon_rombo,
    },
  ])

  useEffect(() => {
    let userInfo = JSON.parse(localStorage.getItem('USER_INFO'))
    if (userInfo) {
      setNameUser(userInfo.name.split(' ')[0])
    }
  }, [])

  const haveTestimonios = () => {
    return challengesCompleted.some(item => item.type === 'urlTestimonio')
  }

  return (
    <section className={`f-banner-home ${isWinner && 'bannerWinner'}`}>
      <GatsbyImage
        objectFit="cover"
        image={withArtDirection(
          getImage(
            nameUser.length < 1
              ? bannerHomeLarge
              : isWinner
              ? bannerHomeLargeYes
              : bannerHomeLargeNot
          ),
          [
            {
              media: '(max-width: 1024px)',
              image: getImage(
                nameUser.length < 1
                  ? bannerHomeSmall
                  : isWinner
                  ? bannerHomeSmallYes
                  : bannerHomeSmallNot
              ),
            },
            {
              media: '(max-width: 1666px)',
              image: getImage(
                nameUser.length < 1
                  ? bannerHomeMedium
                  : isWinner
                  ? bannerHomeMediumYes
                  : bannerHomeMediumNot
              ),
            },
          ]
        )}
        alt="banner-home"
        className="f-banner-home__image"
      />
      <div
        className={`f-banner-home__content ${
          nameUser < 1 ? '' : isWinner ? 'winnerUbication' : 'lossUbication'
        }`}
      >
        {!isLoading && (
          <>
            {nameUser < 1 ? (
              <>
                <p className="f-banner-home__content__text">
                  ¡Conoce si fuiste elegida!
                </p>
                <Button
                  onClick={() => {
                    // pushEventDataLayer({
                    //   event: 'Interacciones - Inscripción',
                    //   category: 'embajadoras-curv',
                    //   action: 'click',
                    //   label: 'INICIAR SESIÓN',
                    //   location: 'nosotras.com/embajadoras',
                    // })
                    dispatch({
                      type: 'set-modal',
                      modalActive: {
                        type: 'login',
                        props: {
                          close: () => {
                            dispatch({ type: 'clear-modal' })
                          },
                          onFinish: () => {
                            dispatch({ type: 'clear-modal' })
                            window.location.reload()
                          },
                        },
                      },
                    })
                  }}
                  title="INICIAR SESIÓN"
                />
              </>
            ) : isAmbassador ? (
              !isLoadingWinner && isWinner ? (
                <>
                  <p className="f-banner-home__content__name">
                    ¡Hola {nameUser}!
                  </p>
                  <p className="f-banner-home__content__name subtitle">
                    Retos en los que has participado:
                  </p>
                  <div className="f-banner-home__content__challengesList">
                    <figure
                      className={`noneNumber ${haveTestimonios() && 'active'}`}
                    >
                      <img
                        src={icon_mision}
                        alt="icono reto de mision de embajadoras"
                      />
                      <p>Tu misión</p>
                    </figure>
                    {challenges.map((item, index) => {
                      let active = challengesCompleted.some(item => {
                        return item.type === `urlReto${index + 1}`
                      })
                      return (
                        <figure
                          className={`reto-${index + 1} ${active && 'active'}`}
                        >
                          <img
                            src={item.img}
                            alt={`icono reto-${index + 1} de embajadoras`}
                          />
                          <p>{item.txt}</p>
                        </figure>
                      )
                    })}
                  </div>
                  <div className="f-banner-home__content__textInfo">
                    <p>
                      ¡Ahora eres una Embajadora Nosotras! Y es súper importante
                      que le cuentes al mundo por qué amas la Tecnología Cur-V y
                      por qué el período no te detiene.
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <p className="f-banner-home__content__text name">
                    Esta vez no fuiste elegida
                  </p>
                  <p className="f-banner-home__content__text textInfo">
                    ¡Pero no te preocupes! Vendrán muchos más concursos para que
                    puedas probar la nueva Tecnología Cur-V
                  </p>
                </>
              )
            ) : (
              <>
                <p className="f-banner-home__content__text name">
                  Esta vez no fuiste elegida
                </p>
                <p className="f-banner-home__content__text textInfo">
                  ¡Pero no te preocupes! Vendrán muchos más concursos para que
                  puedas probar la nueva Tecnología Cur-V
                </p>
              </>
            )}
          </>
        )}
      </div>

      {isMobile
        ? isWinner && <ArrowScrollDown color="pink" scroll={600} />
        : null}
    </section>
  )
}

export default BannerHome
